import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

const ShiekhModal = ({ modalOpen, shiekhInfo, shiekhDetails, onClose, translations }) => {
  if (!modalOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50" onClick={onClose}>
      <div className="bg-white p-6 rounded-lg w-1/2 relative" style={{ fontFamily: "Tajwal, sans-serif" }}>
        <div className="mb-6 bg-gray-100 p-4 rounded relative">
          <div className="absolute top-2 left-2 flex items-center space-x-2">
            <span className="inline-block w-3 h-3 rounded-full" style={{ backgroundColor: shiekhInfo.isActive ? 'green' : 'red' }}></span>
            <span style={{ fontSize: "0.875rem", color: shiekhInfo.isActive ? 'green' : 'red' }}>
              {shiekhInfo.isActive ? 'يعمل' : 'متوقف عن العمل'}
            </span>
          </div>
          <p><strong>اسم الشيخ:</strong> {shiekhInfo.firstName} {shiekhInfo.lastName}</p>
          <p><strong>رقم الهاتف:</strong> {shiekhInfo.phoneNumber}</p>
          <p>{shiekhInfo.email} <strong>:البريد الإلكتروني</strong></p>
          <p><strong>تاريخ الميلاد :</strong> {shiekhInfo.birthDate}</p>
        </div>

        <h4 className="font-bold mb-4">المراكز التي يعمل بها الشيخ</h4>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 250 }} aria-label="shiekh details table">
            <TableHead>
              <TableRow style={{ backgroundColor: '#006A80' }}>
                {["العنوان", "إسم المركز", "تاريخ الانتهاء العمل", "تاريخ البدء العمل"].map((text, index) => (
                  <TableCell key={index} style={{ fontFamily: "Tajwal, sans-serif", color: "white", textAlign: "center" }}>{text}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {shiekhDetails?.length > 0 ? (
                shiekhDetails.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell style={{ textAlign: "center" }}>{item.center?.address}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>{item.center?.name}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>{item.startDate}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>{item.endDate}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">لا توجد بيانات لعرضها</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <button onClick={onClose} className="absolute top-2 left-2 text-white">
          {translations.closeButton}
        </button>
      </div>
    </div>
  );
};

export default ShiekhModal;
